jQuery(document).ready(function($) {
  // Header
  var lastScrollTop = 0;
  $(window).scroll(function(event){
    if ($(window).width() >= 1200) {
      var st = $(this).scrollTop();
      if (st > lastScrollTop) {
        // downscroll code
        if (st > 10) {
          $('.site-header').addClass('fixed');
          $('.site-header__logo-small').removeClass('fadeOut').addClass('fadeIn');
          $('.site-header__logo').removeClass('fadeIn').addClass('fadeOut');
          // $('#AccessibleNav').removeClass('fadeOut').removeClass('fadeIn').addClass('fadeOut').addClass('fadeIn');
        }
      } else {
        // upscroll code
        if (st < 10) {
          $('.site-header').removeClass('fixed');
          $('.site-header__logo-small').removeClass('fadeIn').addClass('fadeOut');
          $('.site-header__logo').removeClass('fadeOut').addClass('fadeIn');
          // $('#AccessibleNav').removeClass('fadeOut').removeClass('fadeIn').addClass('fadeOut').addClass('fadeIn');
        }
      }
      lastScrollTop = st;
    }
  });

  // Home Page
  $('[data-fancybox]').fancybox({
    youtube : {
      controls : 0,
      showinfo : 0
    },
    vimeo : {
      color : 'f00'
    }
  });
  $( "#tabs" ).tabs();

  // PDP
  $('.btn-request-info').click(function(e){
    e.preventDefault();
    $(this).hide();
    $('.request-info-form').show();
  });
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const contact_posted = urlParams.get('contact_posted')
  if( contact_posted === 'true' ) {
    $('.request-info-form').show();
  }

  function createProductSlideshow(option = 'original') {
    if($(document).find('[data-product-json]').length !== 0){
      var json = JSON.parse($('[data-product-json]').html());
      var slides = json.slides;
      var product_slideshow = $('.product-slideshow .jcarousel');
      var data_jcarousel = $('.jcarousel').data( "jcarousel" );

      if(data_jcarousel !== undefined) {
        $('.jcarousel').jcarousel('destroy');
        $('.jcarousel-pagination').jcarouselPagination('destroy');
      }

      $('.product-slideshow ul').html('');

      if( slides !== '' ){
        _.forEach(slides, function(value, key) {
          if( key > 0 ){
            $('.product-slideshow ul').append('<li><a href="'+ value.image_master +'" data-fancybox="gallery"><img src="'+ value.image_thumbnail +'" alt=""></a></li>');
          }
        });
        product_slideshow
        .on('jcarousel:reload jcarousel:create', function () {
          var carousel = $(this),
              width = carousel.innerWidth();

          width = width / 1;

          carousel.jcarousel('items').css('width', Math.ceil(width) + 'px');
        })
        .jcarousel({
          'scroll': 1
        });

        $('.jcarousel-pagination')
        .on('jcarouselpagination:active', 'a', function() {
          $(this).addClass('active');
        })
        .on('jcarouselpagination:inactive', 'a', function() {
          $(this).removeClass('active');
        })
        .on('click', function(e) {
          e.preventDefault();
        })
        .jcarouselPagination({
          'perPage': 1,
          item: function(page) {
            return '<a href="#' + page + '">' + page + '</a>';
          }
        });

        product_slideshow.jcarousel('scroll', 0);
      }
    }
  } // createProductSlideshow();
  // $(document).on('click', '.product-single__art-options input', function(e){
  //   var option = $(this).val();
  //   createProductSlideshow( option );
  // });

  // PLP
  var page = 2;
  $(".btn-load-more").click(function(e){
    e.preventDefault();
    var _this = $(this);
    var handle = _this.data('handle'), handle_mod = '';
    if( handle === 'all' ){ handle_mod = 'allajax' }else{ handle_mod = handle }
    var baseUrl = "/collections/"+handle_mod+"/products.json?limit=12&page="+ page;
    $.ajax({
      dataType: "json",
      url: baseUrl,
      success: function(data){
        // console.log(data);
        var products = jQuery.makeArray( data['products'] );
        var product = '',tag = '';
        $.each( products, function( key, value ) {
          $.each( value.tags, function( key, value ) {
            if (value.indexOf("Athlete_") >= 0) {
              tag = value.replace('Athlete_','');
            }
          });
          var img = value.images[0].src;
          var img_format = img.substring(img.lastIndexOf(".") + 1, img.lastIndexOf("?"));
          img = img.replace(/[.][\w]{3,4}[?]/g, "_x496." + img_format + "?");

          var title = value.title;
          title = title.split('"');
          if( title[1] === undefined ) { title = title[0].split("'"); }

          product =
            '<li class="grid__item grid__item--collection-template small--one-half medium--one-half large-up--one-third">'+
              '<div class="grid-view-item grid-view-item--sold-out product-card">'+
                '<a class="grid-view-item__link grid-view-item__image-container full-width-link" href="/collections/'+ handle +'/products/'+ value.handle +'"><span class="visually-hidden">'+ title[1] +'</span></a>'+
                '<div class="grid-view-item__image-wrapper product-card__image-wrapper js">'+
                  '<div>'+
                    '<img src="'+ img +'" alt="'+ title[1] +'" class="grid-view-item__image">'+
                    '<div class="h4 grid-view-item__title product-card__title" aria-hidden="true">'+
                      '<span class="product-card__title__text">"'+ title[1] +'"</span>'+
                      '<span class="product-card__title__name">'+ tag +'</span>'+
                    '</div>'+
                  '</div>'+
                '</div>'+
                '<div class="clear"></div>'+
              '</div>'+
            '</li>'
          $('.grid--view-items').append( product );
        });
        if( /*products.length < 9 ||*/ products.length == 0 ){
          _this.hide();
        }
        page++;
      },
      error: function(xhr,status,error){
        console.log(xhr);
        console.log(status);
        console.log(error);
      }
    });
  });

  function collectionsidebar(){
    if ($(window).width() >= 769) {
      $( ".sidebar-block:nth-child(1)" ).accordion({collapsible : true, active : 0, header: ".sidebar-block--title", heightStyle: "content"});
      $( ".sidebar-block:nth-child(2)" ).accordion({collapsible : true, active : 1, header: ".sidebar-block--title", heightStyle: "content"});
    }else{
      if(typeof $(".sidebar-block").data("ui-accordion") != "undefined"){
        $( ".sidebar-block" ).accordion("destroy");
      }
      $( ".sidebar-block" ).accordion({collapsible : true, active : false, header: ".sidebar-block--title", heightStyle: "content"});
    }
  }collectionsidebar();

  // Events
  var page = 2, eventButton = $("#btn-load-more-event");
  eventButton.click(function(e){
    e.preventDefault();
    eventsLoadMore(page, eventButton, true);
  });
  function eventsLoadMore(page, button, append){
    var baseUrl = "/blogs/events/?page="+page;
    var post_qty = 1;
    $.ajax({
      type: "GET",
      url: baseUrl,
      dataType: "html",
      success: function(response){
        var len = $.grep($.parseHTML(response), function(el, i) {
          return $(el).hasClass("column")
        }).length;
        if(append){
          $('#events-ajax').append( response );
          post_qty = 4;
        }
        page++;
        if(len < post_qty){
          button.hide();
        }
      }
    });
  }eventsLoadMore(2, eventButton, false );

  // Blog(News)
  var page = 2, newsButton = $("#btn-load-more-news");
  newsButton.click(function(e){
    e.preventDefault();
    newsLoadMore(page, newsButton, true);
  });
  function newsLoadMore(page, button, append){
    var baseUrl = "/blogs/news/?page="+page;
    var post_qty = 1;
    $.ajax({
      type: "GET",
      url: baseUrl,
      dataType: "html",
      success: function(response){
        var len = $.grep($.parseHTML(response), function(el, i) {
          return $(el).hasClass("column")
        }).length;
        if(append){
          $('#news-ajax').append( response );
          post_qty = 8;
        }
        page++;
        if(len < post_qty){
          button.hide();
        }
      }
    });
  }newsLoadMore(2, newsButton, false );

  // Collectors
  $('.collectors-nav a').click(function(e){
    e.preventDefault();
    $('.collectors-element').removeClass('active');
    $([document.documentElement, document.body]).animate({
      scrollTop: $( $(this).attr('href') ).addClass('active').offset().top
    }, 2000);
  });

  // Contact Form
  $( "#ContactForm-date" ).datepicker();

  // Footer
  function footeraccordion(){
    if ($(window).width() <= 414) {
      $( ".site-footer-body" ).accordion({collapsible : true, active : false, header: "h5", heightStyle: "content"});
    }else{
      if(typeof $(".site-footer-body").data("ui-accordion") != "undefined"){
        $( ".site-footer-body" ).accordion("destroy");
      }
    }
  }footeraccordion();

  var resizeId, resizeId2;
  $( window ).resize(function() {
    clearTimeout(resizeId);
    clearTimeout(resizeId2);
    resizeId = setTimeout(footeraccordion, 500);
    resizeId2 = setTimeout(collectionsidebar, 500);
  });
});
